<div class="min-h-screen w-full flex flex-col lg:flex-row bg-gradient-to-br from-white via-[#eaf1ff] to-[#f5f8ff]">
  <div
    class="relative w-full lg:w-1/2 h-[320px] lg:h-screen overflow-hidden
           bg-[radial-gradient(circle_at_top_left,_#3366FF_0%,_#16173A_70%,_#16173A_100%)]"
  >
    <div class="absolute -top-12 -left-24 h-64 w-64 bg-blue-400/30 blur-[120px]"></div>
    <div class="absolute bottom-0 -right-16 h-72 w-72 bg-indigo-900/40 blur-[140px]"></div>

    <div class="relative z-10 p-8 lg:p-12 flex flex-col items-start h-full justify-center">
      <h1 class="text-white font-bold leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
        Protege tu<br />
        Firma<br />
        <span class="text-blue-300">Hoy</span>
      </h1>
    </div>

    <img
      src="/assets/icons/Apolo.svg"
      alt="Logo Apolo"
      class="absolute bottom-[10%] right-[-35%]
             w-[250%] sm:w-[250%] md:w-[200%] lg:w-[166%] xl:w-[125%]
             filter brightness-0 invert pointer-events-none"
    />
  </div>

  <div
    class="relative w-full lg:w-1/2 h-auto lg:h-screen flex items-center justify-center overflow-hidden
           bg-gradient-to-br from-white via-[#eef3ff] to-[#dce8ff]"
  >
    <div class="absolute -top-10 -left-12 h-44 w-44 bg-blue-200/50 blur-[110px]"></div>
    <div class="absolute bottom-[-30px] right-[-40px] h-60 w-60 bg-blue-400/30 blur-[140px]"></div>
    <div class="w-full max-w-xl px-12 py-16">
        <h2 class="text-5xl font-bold text-gray-800 mb-4">Crea tu nueva contraseña</h2>
        <p class="text-lg text-gray-600 mb-12">Tu cuenta requiere un cambio de contraseña antes de continuar.</p>

        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="space-y-10">

          <div>
            <label for="newPassword" class="block text-lg font-medium text-gray-700 mb-2">Nueva contraseña</label>
            <div class="relative">
              <input
                id="newPassword"
                [type]="showNewPassword ? 'text' : 'password'"
                formControlName="newPassword"
                autocomplete="new-password"
                required
                class="py-4 px-4 pe-14 block w-full border border-gray-300 rounded-lg text-lg focus:border-blue-500 focus:ring-blue-500"
                placeholder="Ingresa tu nueva contraseña"
              />
              <button
                type="button"
                (click)="toggleNewPasswordVisibility()"
                class="absolute inset-y-0 right-0 flex items-center z-20 px-4 text-gray-400 hover:text-blue-600"
                [attr.aria-label]="showNewPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              >
                <svg class="shrink-0 w-5 h-5" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <ng-container *ngIf="showNewPassword; else eyeClosedNew">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </ng-container>
                  <ng-template #eyeClosedNew>
                    <path d="m3 3 18 18" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.2 13.2 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.5 13.5 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                  </ng-template>
                </svg>
              </button>
            </div>
          </div>

          <div>
            <label for="confirmPassword" class="block text-lg font-medium text-gray-700 mb-2">Confirmar contraseña</label>
            <div class="relative">
              <input
                id="confirmPassword"
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                autocomplete="new-password"
                required
                class="py-4 px-4 pe-14 block w-full border border-gray-300 rounded-lg text-lg focus:border-blue-500 focus:ring-blue-500"
                placeholder="Confirma tu nueva contraseña"
              />
              <button
                type="button"
                (click)="toggleConfirmPasswordVisibility()"
                class="absolute inset-y-0 right-0 flex items-center z-20 px-4 text-gray-400 hover:text-blue-600"
                [attr.aria-label]="showConfirmPassword ? 'Ocultar confirmación' : 'Mostrar confirmación'"
              >
                <svg class="shrink-0 w-5 h-5" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <ng-container *ngIf="showConfirmPassword; else eyeClosedConfirm">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </ng-container>
                  <ng-template #eyeClosedConfirm>
                    <path d="m3 3 18 18" />
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.2 13.2 0 0 1-1.67 2.68" />
                    <path d="M6.61 6.61A13.5 13.5 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
                  </ng-template>
                </svg>
              </button>
            </div>
          </div>

          <div>
            <button
              type="submit"
              [disabled]="loading"
              class="w-full flex justify-center py-5 px-6 border border-transparent rounded-lg shadow-sm
                     text-xl text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Guardar contraseña
            </button>
          </div>

          <div *ngIf="successMessage" class="text-green-600 text-center text-lg">
            {{ successMessage }}
          </div>

          <div *ngIf="errorMessage" class="text-red-600 text-center text-lg">
            {{ errorMessage }}
          </div>
        </form>

        <div class="mt-10 text-center text-lg">
          <button type="button" class="text-blue-600 hover:text-blue-500 font-medium" (click)="goToLogin()">
            Volver al inicio de sesión
          </button>
  </div>
</div>
  </div>
</div>
